import { Component, OnInit, Input, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Employee, DayEvent, Attendance, TimeLogs } from '../../../models';
import { AmsAttendanceService, AmsTimelogsService } from '../../../services';
import * as moment from 'moment';
import { ToastyService } from 'ng2-toasty';

@Component({
  selector: 'aqua-bulk-time-logs-dialog',
  templateUrl: './bulk-time-logs-dialog.component.html',
  styleUrls: ['./bulk-time-logs-dialog.component.css']
})
export class BulkTimeLogsDialogComponent implements OnInit {

  logs: {
    position: number,
    code: string,
    date: string,
    time: string,
    type: string,
    remarks: string,
    isInValid?: boolean
  }[] = [];
  isLoading = false;



  constructor(
    private amsTimelogsService: AmsTimelogsService,
    public dialogRef: MdDialogRef<BulkTimeLogsDialogComponent>,
    private toastyService: ToastyService,
    @Inject(MD_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.add()
    console.log(this.data)
  }

  validate(item: any) {
    if (item.code && item.time && item.date && item.date) {
      item.isInValid = false;
    }

    if (!item.code) {
      item.isInValid = false;
    }
  }

  remove(item: any) {
    const index = this.logs.findIndex(log => {
      return log.position === item.position
    })

    this.logs.splice(index, 1);
  }

  add() {

    if (this.data) {
      this.logs.push({
        position: this.logs.length,
        code: this.data.empCode,
        date: '',
        time: '',
        remarks: '',
        type: 'checkIn'
      })
    } else {
      this.logs.push({
        position: this.logs.length,
        code: '',
        date: '',
        time: '',
        remarks: '',
        type: 'checkIn'
      })
    }
  }

  save() {
    this.isLoading = true;
    const timeLogs: TimeLogs[] = [];
    let isValid = true;
    this.logs.forEach(log => {
      log.isInValid = false;
      if (!log.code) {
        return;
      }
      if (!log.date || !log.time || !log.type) {
        log.isInValid = true;
        isValid = false;
        return;
      }
      const timeLog = new TimeLogs();
      const checkTimes: string[] = log.time.split(':');
      timeLog.time = moment(log.date).hours(parseInt(checkTimes[0])).minutes(parseInt(checkTimes[1])).toDate()
      timeLog.employee = new Employee()
      timeLog.employee.code = log.code;
      timeLog.type = log.type;
      timeLog.remarks = log.remarks;
      timeLog.source = 'byAdmin';
      timeLogs.push(timeLog)
    });

    if (!isValid) {
      this.toastyService.error({ title: 'Error', msg: 'Some rows are invalid. Please check' });
      return;
    }

    if (!timeLogs.length) {
      this.toastyService.error({ title: 'Error', msg: 'No data to save' });
      return;
    }

    this.amsTimelogsService.timeLogs.bulkCreate(timeLogs).then(() => {
      this.isLoading = false;
      this.dialogRef.close(true);
    }).catch(err => {
      this.isLoading = false;
      this.toastyService.error({ title: 'Error', msg: err });
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/bulk-time-logs-dialog/bulk-time-logs-dialog.component.ts